export const SETTINGS_ROUTE = 'settings'
export const SETTINGS_PACKGO_ROUTE = 'settings.packgo'
export const SETTINGS_PLANS_ROUTE = 'settings.subscriptions.plans'
export const SETTINGS_PLANS_ROUTE_SWITCH = 'settings.subscriptions.plans.switch'
export const SETTINGS_OLD_PLANS_ROUTE = 'settings.subscriptions.plans-old'
export const SETTINGS_PRINTING_ROUTE = 'settings.printing'
export const SETTINGS_NEW_RETURNS_ROUTE = 'settings.return-portal.settings'
export const SETTINGS_NEW_RETURNS_SETTINGS_ROUTE = 'settings.return-portal.settings'
export const SETTINGS_NEW_RETURNS_APPEARANCE_ROUTE = 'settings.return-portal.appearance'
export const SETTINGS_RETURNS_ROUTE = 'settings.return-portal'
export const SETTINGS_SHIPPING_DEFAULTS_ROUTE = 'settings.shipping'
